import styled from 'styled-components';
import { SuccessCheckmark } from '../../../../../generic/components/success-check-mark';

export const CompanySubscriptionContactFormSuccessPage = () => {
  return (
    <Root className={'subscriptionForm'}>
      <div className="success">
        <SuccessCheckmark color={'#f6e65a'} size={'6em'} />
        <h1>Message sent!</h1>
        <p>Thanks for reaching out. We will be in touch during the next business day.</p>
      </div>
    </Root>
  );
};

const Root = styled.div``;
